import React from "react";
import { useHistory } from "react-router-dom";
import AgricultureIcon from "@mui/icons-material/Agriculture";
import PeopleIcon from "@mui/icons-material/People";
import ConstructionIcon from "@mui/icons-material/Construction";
import GavelIcon from "@mui/icons-material/Gavel";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { BarraComportamientoComponent } from "./Components/BarraComportamientoComponent";

export const ChartComportamiento2 = ({ data }) => {
  const history = useHistory();

  const formatmiles = (number) => {
    if (number <= 0) {
      number = 0;
    }
    return Math.floor((number ?? 0) / 1000).toLocaleString("en-US");
  };
  const Gettotal = (cartera) => {
    if (cartera === "Total") {
      return data.reduce((a, b) => a + b.importe, 0);
    }
    return data
      .filter((item) => item.tipo_cartera === cartera)
      .reduce((a, b) => a + b.importe, 0);
  };

  return (
    <table className="chart-recuperacion-table3">
      <tbody>
        <tr>
          <td>
            <AgricultureIcon /> Operación
          </td>
          <td>${formatmiles(Gettotal("Operación"))}</td>
          <td>
            <BarraComportamientoComponent
              element={data.filter((item) => item.tipo_cartera === "Operación")}
            />
          </td>
        </tr>
        <tr>
          <td>
            <ConstructionIcon /> Revolvente
          </td>
          <td>${formatmiles(Gettotal("Revolvente"))}</td>
          <td>
            <BarraComportamientoComponent
              element={data.filter(
                (item) => item.tipo_cartera === "Revolvente"
              )}
            />
          </td>
        </tr>
        <tr>
          <td>
            <PeopleIcon />
            Especial
          </td>
          <td>${formatmiles(Gettotal("Especial"))}</td>
          <td>
            <BarraComportamientoComponent
              element={data.filter((item) => item.tipo_cartera === "Especial")}
            />
          </td>
        </tr>
        <tr>
          <td>
            <GavelIcon /> Mora + 180 dias
          </td>
          <td>${formatmiles(Gettotal("Juridica"))}</td>
          <td>
            <BarraComportamientoComponent
              element={data.filter((item) => item.tipo_cartera === "Juridica")}
            />
          </td>
        </tr>
        <tr>
          <td>
            <AttachMoneyIcon />
            Total
          </td>
          <td>${formatmiles(Gettotal("Total"))}</td>
          <td>
            <BarraComportamientoComponent element={data} prmtotal={true} />
          </td>
        </tr>
      </tbody>
    </table>
  );
};
